import classNames from 'classnames';
import { useRouter } from 'next/router';
import { FC, useRef, useState } from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';

import { ButtonProps } from '~/components/Button/Button';
import Icon from '~/components/Icon';
import StickyDrawer from '~/components/StickyDrawer';
import Text from '~/components/Text';
import CheckoutSummaryDrawer from '../CheckoutSummaryDrawer';

import PayPalButton from '~/components/PaypalButton';
import Colors from '~/constants/colors';
import useClickOutside from '~/hooks/useClickOutside';
import { CartAtom } from '~/services/cart';
import OrderAtom from '~/services/order/order.atom';
import { PaymentMethods } from '~/services/payment';
import { trackingPlaceOrderClick } from '~/services/tracking';

interface CheckoutDrawerProps {
    onClose?: () => void;
    okText?: string;
    okProps?: ButtonProps;
    className?: string;
    formik?: any;
    isPlaceholder?: boolean;
    loadingCart?: boolean;
    disabledPlaceOrder?: boolean;
}

const CheckoutDrawer: FC<CheckoutDrawerProps> = ({
    onClose,
    okText = 'Place order',
    okProps,
    className,
    formik,
    isPlaceholder,
    loadingCart,
    disabledPlaceOrder
}) => {
    const router = useRouter();
    const isCart = router.pathname.includes('/carts');
    const cart = useRecoilValue(CartAtom.cartSelector);
    const checkoutDrawerRef = useRef(null);
    const [showSummaryDrawer, setShowSummaryDrawer] = useState(false);
    const setOrder = useSetRecoilState(OrderAtom.order);

    const close = () => {
        onClose?.();
    };

    useClickOutside(checkoutDrawerRef, close);

    const handleOpenSummaryDrawer = async () => {
        setShowSummaryDrawer(!showSummaryDrawer);
    };

    return (
        <StickyDrawer
            ref={checkoutDrawerRef}
            isHideFooter={formik?.values?.selected_payment_method?.code === PaymentMethods.PAYPAL_EXPRESS}
            className={className}
            primaryButtonText={okText}
            primaryButtonProps={{
                disabled: disabledPlaceOrder,
                onClick: (e: any) => {
                    trackingPlaceOrderClick();
                    okProps?.onClick?.(e);
                }
            }}
        >
            <div className="flex items-center justify-between gap-5">
                <div className="flex flex-col gap-1">
                    <Text type="body-4" color={Colors.GREY_300}>
                        Total
                    </Text>
                    <Text type="title-3" color={Colors.PRIMARY}>
                        ${cart?.total.toFixed(2)}
                    </Text>
                </div>
                <div className="flex items-center gap-2 cursor-pointer" onClick={handleOpenSummaryDrawer}>
                    <Text type="body-3" color={Colors.GREY_900}>
                        See detail
                    </Text>
                    <Icon
                        onClick={close}
                        name="arrow-square-down-2"
                        className={classNames('transition-all', {
                            'rotate-180': showSummaryDrawer
                        })}
                    />
                </div>
            </div>
            {formik?.values?.selected_payment_method?.code === PaymentMethods.PAYPAL_EXPRESS && (
                <div className="flex flex-col py-2 ">
                    {
                        <PayPalButton
                            isPlaceholder={!!isPlaceholder}
                            onPlaceOrder={async () => {
                                formik.handleSubmit();
                            }}
                            formik={formik}
                            disabled={disabledPlaceOrder}
                        />
                    }
                </div>
            )}
            <CheckoutSummaryDrawer
                // okProps={{
                //   onClick: () => {
                //     trackingPlaceOrderClick();
                //     // setOrder({
                //     //   ...cart,
                //     //   // order_number: data?.placeOrder?.order?.order_number,
                //     //   status:OrderStatus.ORDER_PLACED
                //     // });
                //       // router.push("/thank-you");
                //   },
                //   ...okProps,
                // }}

                okText={okText}
                open={showSummaryDrawer}
                onClose={() => setShowSummaryDrawer(false)}
            />
        </StickyDrawer>
    );
};

export default CheckoutDrawer;
